import {
  cloneElement,
  createElement,
  Fragment,
  useSyncExternalStore,
} from 'react'

import { usePromptsStore } from './PromptsContext'

export function Prompts() {
  const store = usePromptsStore()
  const prompts = useSyncExternalStore(store.subscribe, store.getSnapshot)

  return createElement(
    Fragment,
    {},
    prompts.map(({ id, prompt }) =>
      cloneElement(prompt, {
        key: id,
      }),
    ),
  )
}
